import Button from '#/components/Button'
import { reportName } from '#/utils/report'
import UserBlockPreview from './UserBlockPreview'

type Props = {
  property: TopHap.Property
  user: TopHap.UserInfo
  onDownload: () => void
}

const OnePageReportCustomize: React.FC<Props> = ({ property, user, onDownload }) => (
  <div className='w-96'>
    <h3 className='text-xl font-bold text-neutral-800'>
      {reportName('PROPERTY_ONE_PAGE')}
    </h3>
    <p className='my-2 text-sm'>
      <span>
        {property.displayAddress}, {property.displayRegion}
      </span>
    </p>
    <UserBlockPreview user={user} />
    <div className='mt-4 flex justify-end'>
      <Button
        className='h-10 rounded-md bg-gradient-to-r from-primary to-gradient-blue px-3 text-sm text-white'
        onClick={onDownload}
      >
        Download
      </Button>
    </div>
  </div>
)

export default OnePageReportCustomize
